import type { User } from '../platform/types';
import { USER_ROLES } from '../../utils/constants';

/** Roster `GET /v1/roster/students/me` is only valid for users with the STUDENT role. */
export function isEligibleForStudentRosterMe(user: User | null | undefined): boolean {
  return Boolean(user?.roles?.includes(USER_ROLES.STUDENT));
}

export function shouldFetchStudentRosterMe(
  authLoading: boolean,
  isAuthenticated: boolean,
  user: User | null | undefined
): boolean {
  return !authLoading && isAuthenticated && isEligibleForStudentRosterMe(user);
}
